<template>
  <div class="registration" v-loading="loading">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">

        <el-form-item label="类别">
          <el-select v-model="filters.category" clearable="" placeholder="选择类别">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院区">
          <el-select v-model="filters.areaName" placeholder="请选择院区">
            <el-option v-for="item in areaOptions" :key="item.value" :label="item.menuName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户姓名">
          <div class="no">
            <el-select @blur.capture.native="onBlur('clientName')" @change.capture.native="onInput($event,'clientName')" :popper-append-to-body="false" clearable v-model="filters.clientName" placeholder="请输入客户姓名" multiple allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="手机号">
          <div class="no">
            <el-select @blur.capture.native="onBlur('clientMobile')" @change.capture.native="onInput($event,'clientMobile')" :popper-append-to-body="false" clearable v-model="filters.clientMobile" placeholder="请输入手机号" multiple allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="手术编号">
          <div class="no">
            <el-select @blur.capture.native="onBlur('operationNo')" @change.capture.native="onInput($event,'operationNo')" :popper-append-to-body="false" clearable v-model="filters.operationNo" placeholder="请输入手术编号" multiple allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="规范手术名称">
          <el-select v-model="filters.operationNameNo" placeholder="请选择规范手术名称" filterable remote clearable @focus="focus(4)" :filter-method="standMatch">
            <el-option v-for="item in newList4" :key="item.id" :label="item.menuName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场地">
          <el-select v-model="filters.place" placeholder="请选择场地" multiple>
            <el-option v-for="item in placeList" :key="item.id" :label="item.menuName" :value="item.menuName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生">
          <el-select v-model="filters.doctorName" placeholder="请选择医生" multiple filterable remote clearable @focus="focus(1)" :filter-method="doctorMatch">
            <el-option v-for="item in newList1" :key="item.id" :label="item.menuName" :value="item.menuName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号">
          <div class="no">
            <el-select @blur.capture.native="onBlur('clientCard')" @change.capture.native="onInput($event,'clientCard')" :popper-append-to-body="false" clearable v-model="filters.clientCard" placeholder="请输入卡号" multiple allow-create filterable default-first-option></el-select>
          </div>
        </el-form-item>
        <el-form-item label="医助">
          <el-select v-model="filters.assistantName" placeholder="请选择医助" multiple filterable remote clearable @focus="focus(2)" :filter-method="assistMatch">
            <el-option v-for="item in newList2" :key="item.id" :label="item.menuName" :value="item.menuName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="护士">
          <el-select v-model="filters.nurseName" placeholder="请选择护士" multiple filterable remote clearable @focus="focus(3)" :filter-method="nurseMatch">
            <el-option v-for="item in newList3" :key="item.id" :label="item.menuName" :value="item.menuName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="麻醉方式">
          <el-select v-model="filters.anesthesiaMode" placeholder="请选择麻醉方式" multiple>
            <el-option v-for="item in anesList" :key="item.id" :label="item.menuName" :value="item.menuName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class=" buttonText">
        <!-- <div class="delete" @click="exportData">导出外科手术表</div>
        <div class="addData" @click="exportList" v-permission="'92'">导出手术清单</div>
        <div class="addData" @click="add">新增外科登记表</div>
        <div class="addData" @click="del" v-if="keyId==1">删除</div> -->
        <el-button type="warning" @click="add" icon="el-icon-plus">新增外科登记表</el-button>
        <el-button type="danger" @click="del" icon="el-icon-delete" v-if="keyId==1">删除</el-button>
        <el-button type="success" @click="exportData" icon="el-icon-check">导出外科手术表</el-button>
        <el-button type="success" @click="exportList" icon="el-icon-check" v-permission="'92'">导出手术清单</el-button>
        <el-button type="success" @click="exportForm" icon="el-icon-check" v-permission="'92'">导出门诊日志</el-button>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table v-horizontal-scroll="'always'" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}" :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="examine" label="是否审核" width="80" fixed>
          <template slot-scope="scope">
            <el-switch v-model="scope.row.examine" active-color="#13ce66" inactive-color="#C9C9C9" @change="change(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="日期" width="100"></el-table-column>
        <el-table-column prop="therapeuticIndex" label="治疗指数"></el-table-column>
        <el-table-column prop="clientCard" label="客户卡号" width="120"></el-table-column>
        <el-table-column prop="clientName" label="姓名"></el-table-column>
        <el-table-column prop="clientSex" label="性别" width="50"></el-table-column>
        <el-table-column prop="clientAge" label="年龄" width="50"></el-table-column>
        <el-table-column prop="clientIdCard" label="身份证号" width="120">
          <template slot="header">
            <span>身份证号</span>
            <el-button style="margin-left:10px;" v-permission="'90'" @click="show1" class="filter-item" type="success" size="mini" icon="el-icon-view"></el-button>
          </template>
          <template slot-scope="scope">
            <span v-if="idCardHiding==true">{{scope.row.clientIdCard}}</span>
            <span v-if="idCardHiding==false">
              <div v-for="(item,index) in scope.row.clientIdCard.split('/')" :key='index'>{{item.replace(/^(.{6})(?:\d+)(.{4})$/, "$1******$2")}}</div>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="diagnosis" label="诊断" width="150"></el-table-column>
        <el-table-column prop="" label="注/假名称" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.injectionProductList" :key="index">
              <span class="sp">{{item.productName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="标准规格" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.injectionProductList" :key="index">
              <span class="sp">{{item.specification}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="practicalOperationName" label="处理" width="150"></el-table-column>
        <el-table-column prop="registerOperationName" label="处理(标准)" width="150"></el-table-column>
        <el-table-column prop="anesthesiaMode" label="麻醉"></el-table-column>
        <el-table-column prop="assistantName" label="医助"></el-table-column>
        <el-table-column prop="anesthetistName" label="麻醉师"></el-table-column>
        <el-table-column prop="anesthesiaTime" label="麻醉时间" width="100"></el-table-column>
        <el-table-column prop="tourNurse" label="巡回护士"></el-table-column>
        <el-table-column prop="clientMobile" label="联系方式" width="120">
          <template slot="header">
            <span>联系方式</span>
            <el-button style="margin-left:10px;" v-permission="'90'" @click="show" class="filter-item" type="success" size="mini" icon="el-icon-view"></el-button>
          </template>
          <template slot-scope="scope">
            <span v-if="mobileHiding==true">{{scope.row.clientMobile}}</span>
            <span v-if="mobileHiding==false">
              <div v-for="(item,index) in scope.row.clientMobile.split('/')" :key='index'>{{item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")}}</div>
            </span>
          </template>
        </el-table-column>
        <!-- 去掉字符串最后一个逗号 -->
        <!-- <template slot-scope="scope">{{scope.row.doctorName.replace(/,$/gi,"")}}</template> -->
        <el-table-column prop="doctorName" label="手术医生"></el-table-column>
        <el-table-column prop="opear" label="处方医生"></el-table-column>
        <el-table-column prop="practicalOperation" label="实际手术医生"></el-table-column>
        <el-table-column prop="operatorDoctor" label="主刀医生"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>

        <el-table-column prop="category" label="类别"></el-table-column>
        <!-- <el-table-column prop="" label="剩余注射产品"></el-table-column>
        <el-table-column prop="" label="支数"></el-table-column>
        <el-table-column prop="" label="注射金额"></el-table-column>
        <el-table-column prop="" label="手术金额"></el-table-column>
        <el-table-column prop="" label="麻醉金额"></el-table-column> -->

        <el-table-column prop="skinProductName" label="手术材料" width="180">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.productList" :key="index">
              <span class="sp">{{item.productName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.productList" :key="index">
              <span class="sp">{{item.specification}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="使用"></el-table-column>
        <el-table-column prop="number" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.productList" :key="index">
              <span class="sp">{{item.number}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>

        <el-table-column prop="channel" label="渠道" width="150"></el-table-column>
        <el-table-column prop="serviceName" label="客服"></el-table-column>
        <!-- <el-table-column prop="" label="手术分类"></el-table-column>
        <el-table-column prop="category" label="类别"></el-table-column> -->
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" :disabled="scope.row.timeIdentification == true?true:false">编辑</el-button>
            <el-button size="mini" type="warning" @click="handleLog(scope.$index, scope.row)" :disabled="scope.row.identification == 0?true:false">日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增外科登记表弹框 -->
    <addsurgical v-if="dialogForm" ref="addsurgical" :childData="childData" @add-comment="appendComment" :code="code"></addsurgical>
    <!-- 查看日志弹窗 -->
    <el-dialog title="日志" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column prop="createBy" label="操作人" width="150"></el-table-column>
        <el-table-column prop="updateTime" label="操作时间" width="200"></el-table-column>
        <el-table-column prop="operateType" label="操作类型"></el-table-column>
        <el-table-column prop="operateDetails" label="操作内容"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import addsurgical from "./addsurgical.vue";
import { mapState, mapGetters } from 'vuex'
import permission from '../../directives/permission/index'
export default {
  components: {
    // 新增弹框
    addsurgical,
  },
  directives: {
    permission
  },
  name: 'registration',
  computed: {
    ...mapState([]),
    ...mapGetters(['placeList', 'nurseList', 'anesList', 'doctorList', 'assistantList', 'standList']),
  },
  data() {
    return {
      childData: {},
      multipleSelection: [],
      options: [{
        label: '全部 ',
        value: '内外'
      }, {
        label: '内',
        value: '内'
      }, {
        label: '外',
        value: '外'
      },],
      gridData: [],
      dialogTableVisible: false,
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: [_g.getMonths()[0], _g.getMonths()[1]],
        endTime: '',
      },
      tableData: [],
      dialogForm: false,
      loading: false,
      empId: Lockr.get("skinEmpId"),
      jurisdictionId: Lockr.get("skinJurisdictionId"),
      keyId: Lockr.get("skinJurisdictionId").replace(/,/g, ""),
      userName: Lockr.get("skinUserName"),
      areaOptions: [
        {
          id: '全部',
          menuName: '全部'
        },
        {
          id: '伯思立',
          menuName: '伯思立'
        }, {
          id: '百达丽',
          menuName: '百达丽'
        }, {
          id: '翡立思',
          menuName: '翡立思'
        }
      ],
      tableHeight: "",
      inputclientName: '',
      inputmobile: '',
      inputNo: '',
      inputCard: '',
      newList1: [],
      newList2: [],
      newList3: [],
      newList4: [],
      code: '',
      mobileHiding: false,
      idCardHiding: false,
    }
  },
  methods: {
    show() {
      this.mobileHiding = !this.mobileHiding
    },
    show1() {
      this.idCardHiding = !this.idCardHiding
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },

    // 新增注射科登记表
    add() {
      this.dialogForm = true;

      this.$nextTick(() => {
        this.code = 0
        this.$refs.addsurgical.openDialog1Visible();
        this.$refs.addsurgical.openLoading();
        this.childData = {
          clientMobile: '',
          clientCard: '',
          clientName: '',
          serviceName: '',
          clientSex: "",
          clientAge: '',
          serviceName: '',
          category: "",
          time: '',
          areaName: '',
          dsepartmentName: '美容外科',
          operationRegister: [
            {
              operatorDoctor: '',
              anesthetistName: '',
              operationName: [],
              operationNameNo: [],
              diagnosis: '',
              anesthesiaMode: '',
              assistantDoctor: '',
              practicalOperationDoctor: '',
              washNurse: '',
              tourNurse: '',
              remarks: '',
            }
          ],
          operationMaterials: [
            {
              operationName: "",
              practicalOperationName: '',
              doctorName: '',
              nurseName: "",
              assistantName: '',
              anesthetistName: '',
              place: '',
              entranceTime: '',
              operationTimeStart: '',
              operationTimeEnd: '',
              anesthesiaMode: '',
              anesthesiaTimeEnd: "",
              anesthesiaTimeStart: "",
              productList: [
                {
                  productName: '',
                  specification: '',
                  number: '',
                  money: ''
                }
              ],
            }
          ],
          therapeuticIndexList: [
            // {
            //   operationName: "",
            //   operationNameNo: '',
            //   menuName: "",
            //   therapeuticType: '',
            //   operationIndex: '',
            //   therapeuticIndex: '',
            // }
          ],
        }

      });
    },
    appendComment(item) {
      this.query(this.filters.pagination.page);
    },
    // 表格不同行设置不同的样式
    tableRowClassName({
      row,
      rowIndex
    }) {
      // 超过7分则标红，如果有全麻，超过9分则标红
      if (row.identification == 1 && row.indexIdentification == 1) {
        return 'warningBlue';
      } else if (row.indexIdentification == 1) {
        return 'warm-row';
      } else if (row.identification == 1) {
        return 'warningRed';
      }
      return '';

    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    // 查询
    query(page) {
      this.loading = true
      let querys = {
        startTime: "",
        endTime: "",
        page: page,
        size: this.filters.pagination.limit,
        category: this.filters.category,
        jurisdictionId: this.jurisdictionId,
        jurisdictionName: Lockr.get("skinJurisdictionName"),
        createBy: this.empId,
        areaName: this.filters.areaName,
        clientName: this.filters.clientName.toString(),
        clientMobile: this.filters.clientMobile.toString(),
        operationNo: this.filters.operationNo.toString(),
        clientCard: this.filters.clientCard.toString(),
        place: this.filters.place.toString(),
        doctorName: this.filters.doctorName.toString(),
        assistantName: this.filters.assistantName.toString(),
        nurseName: this.filters.nurseName.toString(),
        anesthesiaMode: this.filters.anesthesiaMode.toString(),
        operationNameNo: this.filters.operationNameNo
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      api.request("/register/findSurgeryOperationRegisterList", querys, (res) => {
        // console.log(res)
        var data = res.data.list;
        this.tableData = data
        this.tableData.forEach(ele => {
          ele.opear = '/'
          let reg = new RegExp('，', 'g')//g代表全部
          ele.clientMobile = (ele.clientMobile).replace(reg, '/');
        });
        this.filters.pagination.total = parseInt(res.data.count);
        this.loading = false
      });
    },
    // 导出外科手术表数据
    exportData() {
      let exportUrl = axios.defaults.baseURL;
      var register = {
        total: this.filters.pagination.total,
        category: this.filters.category,
        areaName: this.filters.areaName,
        clientName: this.filters.clientName.toString(),
        clientMobile: this.filters.clientMobile.toString(),
        operationNo: this.filters.operationNo.toString(),
        clientCard: this.filters.clientCard.toString(),
        place: this.filters.place.toString(),
        doctorName: this.filters.doctorName.toString(),
        assistantName: this.filters.assistantName.toString(),
        nurseName: this.filters.nurseName.toString(),
        anesthesiaMode: this.filters.anesthesiaMode.toString(),
        userName: this.userName,
        mobileHiding: this.mobileHiding,
        idCardHiding: this.idCardHiding,
        operationNameNo: this.filters.operationNameNo
      }
      if (this.filters.startTime) {
        register.startTime = this.filters.startTime[0]
        register.endTime = this.filters.startTime[1]
      }
      var formData = new FormData();
      formData.append("register", JSON.stringify(register))
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "register/excelSurgeryOperationRegister", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "外科手术表数据.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportList() {
      let exportUrl = axios.defaults.baseURL;
      var data = this.multipleSelection;
      if (data.length == 0) {
        _g.toast("warning", "请选择要导出的用户!");
        return;
      }
      var id = [];
      data.map(function (item, index) {
        id.push(item.surgeryRegisterId);
      });
      var formData = new FormData();
      formData.append("registerIdList", id.toString())
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "register/wordSurgerySurgicalChecklist", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/msword",
              });
              // console.log(blob, '----------0990');
              const fileName = "外科手术清单";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 查看日志
    handleLog(index, row) {
      this.dialogTableVisible = true
      // 根据id查询当条日志
      let querys = {
        operateType: '美容外科手术表',
        registerId: row.surgeryRegisterId
      }
      api.request("/register/findRegisterLogById", querys, (res) => {
        console.log(res)
        this.gridData = res.data;
      });
    },
    // 编辑
    handleEdit(index, row) {
      this.dialogForm = true;
      this.code = 1
      // 根据id查询详情
      let querys = {
        surgeryRegisterId: row.surgeryRegisterId
      }
      api.request("/register/findSurgeryRegisterById", querys, (res) => {
        // console.log(res.data)
        this.childData = res.data;
        this.childData.operationRegister.forEach((ele, index) => {
          ele.operatorDoctor = ele.operatorDoctor.toString()
          ele.anesthetistName = ele.anesthetistName.toString()
        });
      });
      this.$nextTick(() => {
        this.$refs.addsurgical.openDialog1Visible();
        this.$refs.addsurgical.openLoading();
      });
    },
    del() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        id.push(item.surgeryRegisterId)
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet("/register/deleteSurgeryRegisterById", { surgeryRegisterId: id.toString(), createBy: this.userName, },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    // 姓名多选款
    onBlur(val) {
      if (val == 'clientName') {
        if (this.inputclientName != '' && !this.filters.clientName.includes(this.inputclientName)) {
          this.filters.clientName.push(this.inputclientName)
          this.inputclientName = ''
        }
      } else if (val == 'clientMobile') {
        if (this.inputmobile != '' && !this.filters.clientMobile.includes(this.inputmobile)) {
          this.filters.clientMobile.push(this.inputmobile)
          this.inputmobile = ''
        }
      } else if (val == 'operationNo') {
        if (this.inputNo != '' && !this.filters.operationNo.includes(this.inputNo)) {
          this.filters.operationNo.push(this.inputNo)
          this.inputNo = ''
        }
      } else if (val == 'clientCard') {
        if (this.inputCard != '' && !this.filters.clientCard.includes(this.inputCard)) {
          this.filters.clientCard.push(this.inputCard)
          this.inputCard = ''
        }
      }
    },
    onInput(index, val) {
      if (index.target.value != '') {
        if (val == 'clientName') {
          this.inputclientName = index.target.value
        } else if (val == 'clientMobile') {
          this.inputmobile = index.target.value
        }
        else if (val == 'operationNo') {
          this.inputNo = index.target.value
        }
        else if (val == 'clientCard') {
          this.inputCard = index.target.value
        }
      }
    },
    doctorMatch(val) {
      this.newList1 = _g.paramMatch(this.doctorList, this.newList1, val, 'menuName')
    },
    assistMatch(val) {
      this.newList2 = _g.paramMatch(this.assistantList, this.newList2, val, 'menuName')
    },
    nurseMatch(val) {
      this.newList3 = _g.paramMatch(this.nurseList, this.newList3, val, 'menuName')
    },
    standMatch(val) {
      this.newList4 = _g.paramMatch(this.standList, this.newList4, val, 'menuName')
    },
    focus(val) {
      if (val == 1) {
        this.newList1 = this.doctorList
      } else if (val == 2) {
        this.newList2 = this.assistantList
      } else if (val == 3) {
        this.newList3 = this.nurseList
      } else if (val == 4) {
        this.newList4 = this.standList
      }

    },
    change(index, row) {
      let data = {
        surgeryRegisterId: row.surgeryRegisterId,
        createdBy: this.empId,
        // 0：正常 1：禁用
      }
      api.request("/register/updateSurgeryRegisterExamine", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "标记操作成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "标记操作失败")
          this.query(this.filters.pagination.page)
        }
      })
    },
    exportForm() {
      let exportUrl = axios.defaults.baseURL;
      var register = {
        total: this.filters.pagination.total,
        category: this.filters.category,
        areaName: this.filters.areaName,
        clientName: this.filters.clientName.toString(),
        clientMobile: this.filters.clientMobile.toString(),
        operationNo: this.filters.operationNo.toString(),
        clientCard: this.filters.clientCard.toString(),
        place: this.filters.place.toString(),
        doctorName: this.filters.doctorName.toString(),
        assistantName: this.filters.assistantName.toString(),
        nurseName: this.filters.nurseName.toString(),
        anesthesiaMode: this.filters.anesthesiaMode.toString(),
        userName: this.userName,
        mobileHiding: this.mobileHiding,
        idCardHiding: this.idCardHiding,
        operationNameNo: this.filters.operationNameNo
      }
      if (this.filters.startTime) {
        register.startTime = this.filters.startTime[0]
        register.endTime = this.filters.startTime[1]
      }
      var formData = new FormData();
      formData.append("register", JSON.stringify(register))
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "register/excelSurgeryRegistrationForm", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "外科登记表数据.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.empId == '' || !this.empId) {
      _g.toast("error", '请退出重新登录账号!');
      return;
    }
    this.tableHeight = document.documentElement.clientHeight - 350
  },
  mounted() {
    /*this.init();*/
    this.$store.dispatch('getDataList')
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    },
  },
}
</script>
<style scoped>
@import "../../assets/css/main.css";
.no >>> .el-select-dropdown {
  display: none;
}
.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}
.el-table >>> .warningRed {
  color: #d81212;
}
.el-table >>> .warningBlue {
  color: #d81212;
  background: #f5f1a6;
}
.el-table >>> .warm-row {
  background: #f5f1a6;
}
.registration >>> .el-table .cell {
  text-align: center;
}
.registration >>> .el-button i {
  margin-right: 0px !important;
}
</style>